import * as React from 'react';
import { CancelError } from '../../../utilities/async/CancelError';
import { NameDialog } from '../../nameDialog/NameDialog';
import { IItemCacheState } from '../../../store/reducers/itemCacheReducer';
import strings from '../../scope/actions/createDocument/DocumentCreator.resx';
import { IDispatch } from '../../../store/actions/createActionCreator';
import { IActionProps, IActionBaseProps } from '../../action/Action';
import { IControl } from '../../../models/controls/ControlFacet';
import {
  CreateFolderAction as BaseCreateFolderAction,
  ItemCreateFolderAction as BaseItemCreateFolderAction,
  IItemCreateFolderActionProps as IBaseItemCreateFolderActionProps,
  ICreateFolderActionProps as IBaseCreateFolderActionProps
} from '../../base/actions/createFolder/CreateFolderAction';
import { ISpecifiedItemsProps } from '../../decorators/selectors';
import { injectInitialProps } from '../../../utilities/components/Props';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { ICreateFolderWizardProps } from '../../../controls/createFolderActionControl';

class CreateFolderWizard extends React.PureComponent<ICreateFolderWizardProps> {
  public render(): JSX.Element {
    const {
      resolve,
      reject,
      onCreateFolder,
      maxLength,
      title,
      validator
    } = this.props;

    const onContinue = async (options: {
      name: string;
    }) => {
      if (onCreateFolder) {
        await onCreateFolder(options);
      }

      resolve();
    };

    const onCancel = async () => {
      reject(new CancelError());
    };
    let dialogTitle = (title) ? title : strings.CreateFolder;

    return (
      <NameDialog
        onContinue={ onContinue }
        onCancel={ onCancel }
        title={ dialogTitle }
        maxLength={ maxLength }
        continueText={ strings.CreateCommit }
        name=''
        placeHolder={ strings.FolderNamePlaceholder }
        validator={ validator }
      />
    );
  }
}

export type IItemCreateFolderActionProps =
  IDecoratedProps<IBaseItemCreateFolderActionProps, Pick<IBaseItemCreateFolderActionProps, 'createFolderWizard'>, {}>;

export const ItemCreateFolderAction: React.ComponentType<IItemCreateFolderActionProps> =
  injectInitialProps((): Pick<IBaseItemCreateFolderActionProps, 'createFolderWizard'> => {
    return {
      createFolderWizard: CreateFolderWizard
    };
  })(BaseItemCreateFolderAction);

export type ICreateFolderActionProps =
  IDecoratedProps<IBaseCreateFolderActionProps, Pick<IBaseCreateFolderActionProps, 'createFolderWizard'>, {}>;

export const CreateFolderAction: React.ComponentType<ICreateFolderActionProps> =
  injectInitialProps((): Pick<IBaseItemCreateFolderActionProps, 'createFolderWizard'> => {
    return {
      createFolderWizard: CreateFolderWizard
    };
  })(BaseCreateFolderAction);

// @ts-ignore
type __unused_declarations = Pick<
  IControl<never, never> |
  IActionBaseProps |
  ISpecifiedItemsProps |
  IDispatch<never> |
  IItemCacheState |
  IActionProps |
  React.Component,
  never>;
